export default "__VITE_PUBLIC_ASSET__75fa1054__"